export default "__VITE_ASSET__e1802e98__"